<template>
  <b-card>
    <div class="d-flex my-2">
      <div class="mr-auto"></div>
      <div>
        <b-button size="sm" variant="exitos" @click="addCronograma()">
          <font-awesome-icon icon="plus" />
          Adicionar Evento ao Cronograma
        </b-button>
      </div>
    </div>

    <ul class="timeline">
      <li v-for="(item, index) in items" :key="index">
        <div class="timeline-time">
          <span class="date">{{ item.data_evento | humanize_date }}</span>
          <span class="time">{{ item.data_evento | format_date }}</span>
        </div>

        <div class="timeline-icon" :class="item.tipo_evento">
          <font-awesome-icon icon="calendar-days" />
        </div>

        <div class="timeline-body">
          <div class="timeline-content">
            {{ item.descricao }}
          </div>

          <Actions
            v-if="!item.blocked"
            :item="item"
            :view_show="false"
            :edit_to="null"
            @edit="addCronograma(item.index)"
            @delete="deleteCronograma(item.index)"
          />
        </div>
      </li>
    </ul>

    <div class="d-flex my-2">
      <div class="mr-auto"></div>
      <div>
        <b-button size="sm" variant="exitos" @click="addCronograma()">
          <font-awesome-icon icon="plus" />
          Adicionar Evento ao Cronograma
        </b-button>
      </div>
    </div>

    <b-modal
      title="Evento do Cronograma"
      id="modal-evento-cronograma"
      ref="modal-evento-cronograma"
      size="lg"
      cancel-title="Cancelar"
      ok-title="Salvar"
      ok-variant="exitos"
      @ok="saveCronograma"
      @hidden="resetEdit"
    >
      <form-cronograma :edit="cronograma_edit" ref="form-evento-cronograma" />
    </b-modal>
  </b-card>
</template>

<script>
import Actions from "@/components/Table/Actions.vue";
import FormCronograma from "./Cronograma/FormCronograma.vue";
import { validationMixin } from "vuelidate";
import { mapState } from "vuex";
import { orderBy } from "lodash";

export default {
  components: { FormCronograma, Actions },
  mixins: [validationMixin],
  data: () => ({
    edit_index: null,
  }),
  validations: {
    oportunidade: {},
  },
  computed: {
    ...mapState("oportunidades", ["oportunidade"]),
    cronograma_edit() {
      let cronograma = null;

      if (this.oportunidade.cronograma[this.edit_index]) {
        cronograma = {
          ...this.oportunidade.cronograma[this.edit_index],
        };
      }

      return cronograma;
    },
    items() {
      let items = [];

      if (this.oportunidade.data_disponibilizacao) {
        items.push({
          data_evento: this.oportunidade.data_disponibilizacao,
          descricao: "Disponibilização da oportunidade",
          blocked: true,
        });
      }

      if (this.oportunidade.data_proposta_ini) {
        items.push({
          data_evento: this.oportunidade.data_proposta_ini,
          descricao: "Inicio das propostas",
          blocked: true,
        });
      }

      if (this.oportunidade.data_proposta_fim) {
        items.push({
          data_evento: this.oportunidade.data_proposta_fim,
          descricao: "Encerramento das propostas",
          blocked: true,
        });
      }

      this.oportunidade.cronograma.forEach((cronograma, index) => {
        items.push({
          ...cronograma,
          index: index,
        });
      });

      return orderBy(items, ["data_evento"]);
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.oportunidade[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.oportunidade.$touch();
      return !this.$v.oportunidade.$anyError;
    },
    addCronograma(index = null) {
      this.$bvModal.show("modal-evento-cronograma");

      this.$nextTick(() => {
        this.edit_index = index;
      });
    },
    saveCronograma(evt) {
      evt.preventDefault();
      let cronograma = this.$refs["form-evento-cronograma"].save();
      if (cronograma) {
        cronograma.oportunidade_id = this.oportunidade.id;
        if (this.edit_index && this.oportunidade.cronograma[this.edit_index]) {
          let cronograma_eventos = JSON.parse(
            JSON.stringify(this.oportunidade.cronograma)
          );
          cronograma_eventos[this.edit_index] = cronograma;
          this.oportunidade.cronograma = cronograma_eventos;
        } else {
          this.oportunidade.cronograma.push(cronograma);
        }

        this.$nextTick(() => {
          this.$bvModal.hide("modal-evento-cronograma");
        });
      }
    },
    deleteCronograma(index) {
      this.oportunidade.cronograma.splice(index, 1);
    },
    resetEdit() {
      this.edit_index = null;
    },
  },
  created() {},
};
</script>
